module.exports = __webpack_public_path__ + "static/media/thumnail-default.51957900.svg";